import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  /* Reset or base styles if needed */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Font smoothing and default font */
  body {
    font-family: "Poppins", sans-serif;
    background-color: #0c1c2c;
    color: white;
    overflow-x: hidden;
  }

  /* Custom scrollbar styles */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #0c1c2c;
  }

  ::-webkit-scrollbar-thumb {
    background: #132a41; /* Darker blue thumb */
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #1a3c5f; /* Slightly lighter on hover */
  }

  /* Firefox support */
  * {
    scrollbar-width: thin;
    scrollbar-color: #132a41 #0c1c2c;
  }
`;

export default GlobalStyle;
